import React from 'react';
import loadable from '@loadable/component';

import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import NotFoundPage from '../containers/NotFoundPage/NotFoundPage';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';

import CustomerLandingPage from '../containers/CustomerLandingPage/CustomerLandingPage';
import CustomOffsiteConstructionPage from '../containers/CustomOffsiteConstructionPage/CustomOffsiteConstructionPage';
import LandFindingPage from '../containers/LandFindingPage/LandFindingPage';
import InsuranceAndFinancePage from '../containers/InsuranceAndFinancePage/InsuranceAndFinancePage';
import GroundworksContractorsPage from '../containers/GroundworksContractorsPage/GroundworksContractorsPage';
import FinancePage from '../containers/FinancePage/FinancePage';
import ArchitectsAndPlanningConsultancyPage from '../containers/ArchitectsAndPlanningConsultancyPage/ArchitectsAndPlanningConsultancyPage';
import StructuralEngineersPage from '../containers/StructuralEngineersPage/StructuralEngineersPage';
import OffsiteSuppliersPage from '../containers/OffsiteSuppliersPage/OffsiteSuppliersPage';


const pageDataLoadingAPI = getPageDataLoadingAPI();

const AdminDreamListingReviewPage = loadable(() => import(/* webpackChunkName: "AdminDreamListingReviewPage" */ '../containers/AdminDreamListingReviewPage/AdminDreamListingReviewPage'));
const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPage'));
const CostEstimationDetailsPage = loadable(() => import(/* webpackChunkName: "CostEstimationDetailsPage" */ '../containers/CostEstimationDetailsPage/CostEstimationDetailsPage'));
const CustomerCostEstimationToolPage = loadable(() => import(/* webpackChunkName: "CustomerCostEstimationToolPage" */ '../containers/CustomerCostEstimationToolPage/CustomerCostEstimationToolPage'));
const DreamHomePage = loadable(() => import(/* webpackChunkName: "DreamHomePage" */ '../containers/DreamHomePage/DreamHomePage'));
const DocumentManagementPage = loadable(() => import(/* webpackChunkName: "DocumentManagementPage" */ '../containers/DocumentManagementPage/DocumentManagementPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPage'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCarousel'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPage'));
const PropertyDeveloperPage = loadable(() => import(/* webpackChunkName: "PropertyDeveloperPage" */ '../containers/PropertyDeveloperPage/PropertyDeveloperPage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithMap'));
const SearchPageWithGrid = loadable(() => import(/* webpackChunkName: "SearchPageWithGrid" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithGrid'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPage'));
const SupplierCostEstimationToolPage = loadable(() => import(/* webpackChunkName: "SupplierCostEstimationToolPage" */ '../containers/SupplierCostEstimationToolPage/SupplierCostEstimationToolPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPage'));

// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ '../containers/StyleguidePage/StyleguidePage'));

// Custom pages
const CustomLandingPage = loadable(() => import(/* webpackChunkName: "CustomLandingPage" */ '../containers/CustomLandingPage/CustomLandingPage'));
const CustomAboutUsPage = loadable(() => import(/* webpackChunkName: "CustomAboutUsPage" */ '../containers/CustomAboutUsPage/CustomAboutUsPage'));
const CustomHowItWorksPage = loadable(() => import(/* webpackChunkName: "CustomHowItWorksPage" */ '../containers/CustomHowItWorksPage/CustomHowItWorksPage'));
const CustomMMCPage = loadable(() => import(/* webpackChunkName: "CustomMMCPage" */ '../containers/CustomMMCPage/CustomMMCPage'));
const CustomBlogPage = loadable(() => import(/* webpackChunkName: "CustomBlogPage" */ '../containers/CustomBlogPage/CustomBlogPage'));
const CustomPricingPage = loadable(() => import(/* webpackChunkName: "CustomPricingPage" */ '../containers/CustomPricingPage/CustomPricingPage'));
const FaqPage = loadable(() => import(/* webpackChunkName: "FaqPage" */ '../containers/FaqPage/FaqPage'));
const CustomTermsAndConditionsPage = loadable(() => import(/* webpackChunkName: "CustomTermsAndConditionsPage" */ '../containers/CustomTermsAndConditionsPage/CustomTermsAndConditionsPage'));
const CustomPrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "CustomPrivacyPolicyPage" */ '../containers/CustomPrivacyPolicyPage/CustomPrivacyPolicyPage'));
const CustomMoodMapPage = loadable(() => import(/* webpackChunkName: "CustomMoodMapPage" */ '../containers/CustomMoodMapPage/CustomMoodMapPage'));
const CustomCostCalculatorPage = loadable(() => import(/* webpackChunkName: "CustomCostCalculatorPage" */ '../containers/CustomCostCalculatorPage/CustomCostCalculatorPage'));
const CustomCommunityPage = loadable(() => import(/* webpackChunkName: "CustomCommunityPage" */ '../containers/CustomCommunityPage/CustomCommunityPage'));
const CustomArticlePage = loadable(() => import(/* webpackChunkName: "CustomArticlePage" */ '../containers/CustomArticlePage/CustomArticlePage'));
const CustomTrustedSuppliersPage = loadable(() => import(/* webpackChunkName: "CustomTrustedSuppliersPage" */ '../containers/CustomTrustedSuppliersPage/CustomTrustedSuppliersPage'));
const DeveloperLandingPage = loadable(() => import(/* webpackChunkName: "DeveloperLandingPage" */ '../containers/DeveloperLandingPage/DeveloperLandingPage'));
const BlogPage = loadable(() => import(/* webpackChunkName: "BlogPage" */ '../containers/BlogPage/BlogPage'));
const SingleBlogPage = loadable(() => import(/* webpackChunkName: "SingleBlogPage" */ '../containers/SingleBlogPage/SingleBlogPage'));
const ContactSupplierPage = loadable(() => import(/* webpackChunkName: "ContactSupplierPage" */ '../containers/ContactSupplierPage/ContactSupplierPage'));
const LeadFlowPage = loadable(() => import(/* webpackChunkName: "LeadFlowPage" */ '../containers/LeadFlowPage/LeadFlowPage'));
const StartYourProjectPage = loadable(() => import(/* webpackChunkName: "StartYourProjectPage" */ '../containers/StartYourProjectPage/StartYourProjectPage'));
const LocationPage = loadable(() => import(/* webpackChunkName: "LocationPage" */ '../containers/LocationPage/LocationPage'));
const PreviewPage = loadable(() => import(/* webpackChunkName: "PreviewPage" */ '../containers/PreviewPage/PreviewPage'));
const SeoPreviewPage = loadable(() => import(/* webpackChunkName: "SeoPreviewPage" */ '../containers/SeoPreviewPage/SeoPreviewPage'));

export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
export const draftId = '00000000-0000-0000-0000-000000000000';
export const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig) => {
  const SearchPage = layoutConfig?.searchPage?.variantType === 'map' 
    ? SearchPageWithMap 
    : SearchPageWithGrid;
  const ListingPage = layoutConfig?.listingPage?.variantType === 'carousel' && typeof window !== 'undefined'
    ? ListingPageCarousel 
    : ListingPageCoverPhoto;
  
  return [
    {
      path: '/',
      name: 'LandingPage',
      component: CustomLandingPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/leadflow',
      name: 'LeadFlowPage',
      component: LeadFlowPage,
    },
    {
      path: '/locations/:slug',
      name: 'LocationPage',
      component: LocationPage,
    },
    {
      path: '/preview/:token/:slug',
      name: 'PreviewPage',
      component: PreviewPage,
    },
    {
      path: '/_preview/:token',
      name: 'SeoPreviewPage',
      component: SeoPreviewPage,
    },
    {
      path: '/startyourproject',
      name: 'StartYourProjectPage',
      component: StartYourProjectPage,
    },
    {
      path: '/admin-review/:slug/:id',
      name: 'AdminDreamListingReviewPage',
      component: AdminDreamListingReviewPage,
      loadData: pageDataLoadingAPI.AdminDreamListingReviewPage.loadData,
    },
    {
      path: '/review-brief/:slug/:id',
      name: 'DreamListingReviewPage',
      component: AdminDreamListingReviewPage,
      loadData: pageDataLoadingAPI.AdminDreamListingReviewPage.loadData,
    },
    {
      path: '/your-dream-home/:tab',
      name: 'DreamHomePage',
      component: DreamHomePage,
      loadData: pageDataLoadingAPI.DreamHomePage.loadData,
    },
    {
      path: '/property-developer/:tab',
      name: 'PropertyDeveloperPage',
      component: PropertyDeveloperPage,
      loadData: pageDataLoadingAPI.PropertyDeveloperPage.loadData,
    },
    {
      path: '/document-management',
      name: 'DocumentManagementPage',
      auth: true,
      authPage: 'LoginPage',
      component: DocumentManagementPage,
      loadData: pageDataLoadingAPI.DocumentManagementPage.loadData,
    },
    {
      path: '/customer/cost-estimation-tool',
      name: 'CustomerCostEstimationToolPage',
      auth: true,
      authPage: 'LoginPage',
      component: CustomerCostEstimationToolPage,
      loadData: pageDataLoadingAPI.CustomerCostEstimationToolPage.loadData,
    },
    {
      path: '/cost-estimation',
      name: 'CostEstimationDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: CostEstimationDetailsPage,
      loadData: pageDataLoadingAPI.CostEstimationDetailsPage.loadData,
    },
    {
      path: '/supplier/cost-estimation-tool',
      name: 'SupplierCostEstimationToolPage',
      auth: true,
      authPage: 'LoginPage',
      component: SupplierCostEstimationToolPage,
      loadData: pageDataLoadingAPI.SupplierCostEstimationToolPage.loadData,
    },
    {
      path: '/trusted-suppliers',
      name: 'TrustedSuppliersPage',
      component: CustomTrustedSuppliersPage
    },
    {
      path: '/community',
      name: 'CommunityPage',
      component: CustomCommunityPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/article/:id',
      name: 'ArticlePage',
      component: CustomArticlePage,
    },
    {
      path: '/self-build-blogs/how-much-does-it-cost-to-self-build-a-house-in-2026',
      name: 'CostCalculatorPage',
      auth: false,
      component: CustomCostCalculatorPage
    },
    {
      path:'/faq',
      name: 'FaqPage',
      component: FaqPage,
    },
    {
      path: '/about',
      name: 'AboutUsPage',
      component: CustomAboutUsPage,
    },
    {
      path: '/mood-board',
      name: 'MoodMapPage',
      component: CustomMoodMapPage,
    },
    {
      path: '/how-it-works',
      name: 'HowItWorksPage',
      component: CustomHowItWorksPage
    },
    {
      path: '/offsite-construction',
      name: 'CustomOffsiteConstructionPage',
      component: CustomOffsiteConstructionPage
    },
    
    {
      path: '/mmc',
      name: 'MMCPage',
      component: CustomMMCPage
    },
    {
      path: '/self-build-blogs',
      name: 'CustomBlogPage',
      component: CustomBlogPage
    },
    {
      path: '/pricing',
      name: 'PricingPage',
      component: CustomPricingPage
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    {
      path: '/home-designs',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:slug/:id',
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/l/:slug/:id/contact-supplier',
      name: 'ContactSupplierPage',
      noSSR: true,
      component: ContactSupplierPage,
      loadData: pageDataLoadingAPI.ContactSupplierPage.loadData,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },

    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },

    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/signup',
      name: 'SignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    // Note: loadData removed from supplier/customer signup routes to prevent 500 errors
    // when terms-of-service/privacy-policy assets are unavailable in Sharetribe Asset API.
    // The AuthenticationPage component handles missing assets gracefully with optional chaining.
    {
      path: '/signup-supplier',
      name: 'SupplierSignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup', isSupplierSignup: true },
    },
    {
      path: '/signup-customer',
      name: 'CustomerSignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup', isCustomerSignup: true },
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: CustomPrivacyPolicyPage
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage ,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    // Do not change this path!
    //
    // The API expects that the application implements /preview endpoint
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage ,
    },
    {
      path: '/home/developers',
      name: 'DeveloperLandingPage',
      auth: true,
      authPage: 'CustomerSignupPage',
      component: DeveloperLandingPage,
    },

    {
      path: '/home/customers',
      name: 'CustomerLandingPage',
      auth: true,
      authPage: 'CustomerSignupPage',
      component: CustomerLandingPage,
    },
    {
      path: '/blogs',
      name: 'BlogPage',
      component: BlogPage,
    },
    {
      path: '/blog/:title',
      name: 'SingleBlogPage',
      component: SingleBlogPage,
    },
    {
      path: '/land-finding',
      name: 'LandFindingPage',
      component: LandFindingPage,
    },
    {
      path: '/insurance',
      name: 'InsuranceAndFinancePage',
      component: InsuranceAndFinancePage,
    },
    {
      path: '/groundworks-contractors',
      name: 'GroundworksContractorsPage',
      component: GroundworksContractorsPage,
    },
    {
      path: '/finance',
      name: 'FinancePage',
      component: FinancePage,
    },
    {
      path: '/architects-planning-consultancy',
      name: 'ArchitectsAndPlanningConsultancyPage',
      component: ArchitectsAndPlanningConsultancyPage,
    },
    
    {
      path: '/structural-engineers',
      name: 'StructuralEngineersPage',
      component: StructuralEngineersPage,
    },
    {
      path: '/offsite-suppliers',
      name: 'OffsiteSuppliersPage',
      component: OffsiteSuppliersPage,
    },
    
    
    
  ];
};

export default routeConfiguration;
